document.addEventListener('DOMContentLoaded', function () {
  // Read config injected by Liquid
  var configEl = document.getElementById('id-kit-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.error('ID Kit: failed to parse config', e);
    return;
  }

  var kitProducts = config.kitProducts || [];
  if (kitProducts.length === 0) return;

  // Elements
  var popup        = document.getElementById('custom-popup');
  var popup1       = document.getElementById('custom_popup1');
  var popup2       = document.getElementById('custom_popup2');
  var closeBtn     = document.getElementById('close-popup');
  var triggerBtn   = document.getElementById('custom_add_kits_btn');
  var previewImage = document.getElementById('kit-preview-image');
  var styleSelect  = document.getElementById('kits-jersey-style');
  var styleWrapper = document.getElementById('kits-style-wrapper');
  var reviewStyle  = document.getElementById('review-style-container');

  if (!popup || !triggerBtn) return;

  // --- Populate style select or hide if only one kit ---
  if (kitProducts.length === 1) {
    if (styleWrapper) styleWrapper.style.display = 'none';
    if (reviewStyle)  reviewStyle.style.display  = 'none';
  } else {
    kitProducts.forEach(function (kit) {
      var opt = document.createElement('option');
      opt.value = kit.title;
      opt.textContent = kit.title;
      styleSelect.appendChild(opt);
    });

    if (styleSelect && previewImage) {
      styleSelect.addEventListener('change', function () {
        var kit = kitProducts.find(function (k) { return k.title === styleSelect.value; });
        if (kit && kit.image) previewImage.src = kit.image;
      });
    }
  }

  // Set initial preview image
  if (previewImage && kitProducts[0] && kitProducts[0].image) {
    previewImage.src = kitProducts[0].image;
  }

  // --- Get the currently selected kit ---
  function getSelectedKit() {
    if (kitProducts.length === 1) return kitProducts[0];
    if (!styleSelect || !styleSelect.value) return null;
    return kitProducts.find(function (k) { return k.title === styleSelect.value; }) || null;
  }

  // --- Reset popup to initial state ---
  function resetPopup() {
    var nameInput   = document.getElementById('kits-name');
    var numberInput = document.getElementById('kits-number');

    if (nameInput)   nameInput.value = '';
    if (numberInput) numberInput.value = '';
    if (styleSelect && kitProducts.length > 1) styleSelect.selectedIndex = 0;

    var p2name   = document.getElementById('custom_popup2-kits-name');
    var p2number = document.getElementById('custom_popup2-kits-number');
    var p2style  = document.getElementById('custom_popup2-kits-style');
    if (p2name)   p2name.innerText   = '';
    if (p2number) p2number.innerText = '';
    if (p2style)  p2style.innerText  = '';

    var addCartBtn = document.getElementById('custom_kits_add_cart');
    if (addCartBtn) {
      addCartBtn.disabled    = false;
      addCartBtn.textContent = 'Add to Jersey - $45';
    }

    popup.style.display  = 'none';
    popup1.style.display = 'block';
    popup2.style.display = 'none';
  }

  // --- Open popup ---
  triggerBtn.addEventListener('click', function (e) {
    e.preventDefault();
    popup.style.display = 'flex';
  });

  // --- Close: X button ---
  closeBtn.addEventListener('click', resetPopup);

  // --- Close: outside click ---
  popup.addEventListener('click', function (e) {
    if (e.target === popup) resetPopup();
  });

  // --- Next button (step 1 → step 2) ---
  document.getElementById('custom_kits_submit_component').addEventListener('click', function () {
    var nameValue   = document.getElementById('kits-name').value.trim();
    var numberValue = document.getElementById('kits-number').value.trim();

    if (!nameValue) {
      alert('Please fill in the Name field.');
      return;
    }
    if (!numberValue) numberValue = 'none';

    if (kitProducts.length > 1 && !styleSelect.value) {
      alert('Please select a Jersey Style.');
      return;
    }

    document.getElementById('custom_popup2-kits-name').innerText   = nameValue;
    document.getElementById('custom_popup2-kits-number').innerText = numberValue;

    var p2style = document.getElementById('custom_popup2-kits-style');
    if (p2style && kitProducts.length > 1) p2style.innerText = styleSelect.value;

    popup2.style.display = 'block';
    popup1.style.display = 'none';
  });

  // --- Back to edit ---
  document.getElementById('back-to-edit-button').addEventListener('click', function (e) {
    e.preventDefault();
    popup2.style.display = 'none';
    popup1.style.display = 'block';
  });

  // --- SUBMIT: add jersey + kit to cart immediately ---
  document.getElementById('custom_kits_add_cart').addEventListener('click', function () {
    var kit = getSelectedKit();
    if (!kit) {
      alert('Please select a jersey style.');
      return;
    }

    var nameValue   = document.getElementById('custom_popup2-kits-name').innerText.trim();
    var numberValue = document.getElementById('custom_popup2-kits-number').innerText.trim();

    var jerseyVariantId = document.querySelector('input[name="id"]').value;
    var jerseyName      = document.querySelector('input[name="id_name"]').value;
    var jerseySku       = document.querySelector('input[name="id_sku"]').value;
    var sizeInput       = document.querySelector('input[name="selected_size"]');
    var jerseySize      = sizeInput ? sizeInput.value : '';

    var kitProperties = {
      Name:          nameValue,
      Number:        numberValue || 'none',
      Jersey:        jerseyName,
      'Jersey Size': jerseySize,
      'Jersey SKU':  jerseySku
    };

    var pairId = Date.now().toString();
    kitProperties['_pair_id'] = pairId;

    var submitBtn = this;
    submitBtn.disabled    = true;
    submitBtn.textContent = 'Adding...';

    // Add kit FIRST so jersey (added second) is newest and appears above kit in checkout
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: Number(kit.variantId), quantity: 1, properties: kitProperties })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      return fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: Number(jerseyVariantId), quantity: 1, properties: { '_customized': 'Name & Number', '_pair_id': pairId } })
      });
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      resetPopup();
      var miniCart = document.getElementById('mini-cart');
      if (miniCart) miniCart.open = true;
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail:  { cart: cart }
      }));
    })
    .catch(function (err) {
      console.error('ID Kit: error adding to cart', err);
      submitBtn.disabled    = false;
      submitBtn.textContent = 'Add to Jersey - $45';
    });
  });
});

// --- Mini-cart jersey remove: also remove paired kit ---
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.line-item__remove-button');
  if (!btn) return;
  var lineItem = btn.closest('line-item[data-kit-key]');
  if (!lineItem) return;
  e.preventDefault();
  var kitKey     = lineItem.getAttribute('data-kit-key');
  var jerseyKey  = lineItem.getAttribute('data-jersey-key');
  var updates    = {};
  updates[kitKey]    = 0;
  updates[jerseyKey] = 0;
  fetch('/cart/update.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ updates: updates })
  })
  .then(function (r) { return r.json(); })
  .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
  .then(function (cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail:  { cart: cart }
    }));
  })
  .catch(function (err) { console.error('ID Kit: jersey+kit remove error:', err); });
});

// --- Kit remove: delegated handler (works after cart re-renders) ---
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-kit-remove]');
  if (!btn) return;
  e.preventDefault();
  var id = btn.getAttribute('data-kit-remove');
  fetch('/cart/change.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ id: id, quantity: 0 })
  })
  .then(function (r) { return r.json(); })
  .then(function (cart) {
    if (window.location.pathname === '/cart') {
      window.location.reload();
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail:  { cart: cart }
      }));
    }
  })
  .catch(function (err) { console.error('Kit remove error:', err); });
});
